import React, { useEffect, useRef, useState } from "react";
import { local } from "@/lib/api";

const DEFAULT = {
  message: "Don't know what is wrong? Check out FendanaDoc MediGuide, the pocket guide to your health concerns. Available on App Store and Google Play for download.",
  colors: ["#FF6F61", "#B39DDB", "#7EC8E3"],
};

// Global config-driven marquee at the very top of every FHAPAS screen.
export function Ticker() {
  const [cfg, setCfg] = useState(null);
  const [idx, setIdx] = useState(0);
  const ref = useRef(null);

  // Publish ticker height so fixed sidebars / sticky headers sit below it.
  useEffect(() => {
    const root = document.documentElement;
    const el = ref.current;
    if (!el) { root.style.setProperty("--ticker-h", "0px"); return undefined; }
    const ro = new ResizeObserver(() => root.style.setProperty("--ticker-h", `${el.offsetHeight}px`));
    ro.observe(el);
    return () => { ro.disconnect(); root.style.setProperty("--ticker-h", "0px"); };
  }, [cfg]);

  useEffect(() => { local.get("/ticker").then((r) => setCfg(r.data)).catch(() => setCfg(DEFAULT)); }, []);

  const colors = cfg?.colors?.length ? cfg.colors : DEFAULT.colors;
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % colors.length), 4000);
    return () => clearInterval(t);
  }, [colors.length]);

  if (cfg && cfg.enabled === false) return null;
  const msg = cfg?.message || DEFAULT.message;
  const appUrl = cfg?.app_store_url;
  const playUrl = cfg?.play_store_url;

  const Block = () => (
    <span className="mx-8 inline-flex items-center gap-3 text-sm font-bold tracking-wide text-white drop-shadow-sm">
      {appUrl ? <a href={appUrl} target="_blank" rel="noreferrer" data-testid="ticker-msg-link" className="hover:underline">{msg}</a> : msg}
      {appUrl && <a href={appUrl} target="_blank" rel="noreferrer" data-testid="ticker-appstore-link" className="rounded-full bg-white/25 px-2 py-0.5 hover:bg-white/40">App Store</a>}
      {playUrl && <a href={playUrl} target="_blank" rel="noreferrer" data-testid="ticker-playstore-link" className="rounded-full bg-white/25 px-2 py-0.5 hover:bg-white/40">Google Play</a>}
    </span>
  );

  return (
    <div data-testid="global-ticker" ref={ref} className="fhapas-ticker sticky top-0 z-[70] overflow-hidden" style={{ backgroundColor: colors[idx % colors.length] }}>
      <div className="fhapas-ticker-track whitespace-nowrap py-1.5">
        <Block /><Block />
      </div>
    </div>
  );
}
